import React, { useEffect, useState } from "react";
import Header from "../../componets/Header";
import { Link } from "react-router-dom";
import { FaCircleArrowLeft } from "react-icons/fa6";
import {
	Badge,
	Card,
	CardBody,
	Modal,
	Pagination,
	Table,
	Form,
} from "react-bootstrap";
import ApiService from "../../helper/api";
import MainService from "../../helper/mainService";
import moment from "moment";

function Component(props) {
	const [data, setData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pagination, setPagination] = useState(null);

	const [isNew, setIsNew] = useState(true);
	const [modalInformation, setModalInformation] = useState({
		open: false,
		item: null,
	});

	useEffect(() => {
		notificationGetAll();
	}, []);

	const notificationGetAll = (pageNumber = 1, isNew = false) => {
		const pagination = {
			pageNumber: pageNumber,
			pageSize: 10,
		};
		MainService.callApi({
			api: ApiService.notificationGetAll,
			data: { pagination, isNew },
			cb: response => {
				if (response?.data?.pagedData?.length) {
					setData(response?.data?.pagedData);
				} else {
					setData([]);
				}
				if (response?.data?.pagination) {
					setPagination(response?.data?.pagination);
				}
				setCurrentPage(pageNumber);
				setIsNew(isNew);
			},
		});
	};

	// useEffect(() => {
	// 	if (configs?.length) {
	// 		setData(configs);
	// 	}
	// }, [configs]);

	// const configGetAll = () => {
	// 	MainService.callApi({
	// 		api: ApiService.configGetAll,
	// 		cb: response => {
	// 			if (response && response.data && response.data.length) {
	// 				setData(response.data);
	// 			}
	// 		},
	// 	});
	// };

	// const closeModal = () => {
	// 	setIsShowForm({ open: false, config: null });
	// };

	// const configDelete = id => {
	// 	setDisabledButton(id);
	// 	AlertService.alertConfirm("Are you sure ?")
	// 		.then(res => {
	// 			MainService.callApi({
	// 				api: ApiService.configDelete,
	// 				data: id,
	// 				cb: res => {
	// 					if (res.success) {
	// 						AlertService.alert("success", "Data seved");
	// 						setData(data => data.filter(item => item.id !== id));
	// 					}
	// 				},
	// 				_finally: () => {
	// 					setDisabledButton(null);
	// 				},
	// 			});
	// 		})
	// 		.catch(error => {})
	// 		.finally(() => {});
	// };

	const handlePageChange = pageNumber => {
		notificationGetAll(+pageNumber, isNew);
	};

	const closeModal = () => {
		setModalInformation({});
	};

	const openModal = item => {
		if (!item) return false;
		let newItem = { ...item };
		if (!item.isReed) {
			MainService.callApi({
				api: ApiService.notificationUpdate,
				data: item.id,
				cb: response => {
					if (response.success) {
						setData(data =>
							data.map(el => ({
								...el,
								isReed: el.id === item.id ? true : el.isReed,
							})),
						);
					}
				},
				_finally: () => {
					setModalInformation({
						open: true,
						item: item,
					});
				},
			});
		} else {
			setModalInformation({
				open: true,
				item: item,
			});
		}
	};

	return (
		<div>
			<Modal
				show={modalInformation.open}
				size="lg"
				scrollable
				centered
				onHide={() =>
					closeModal({
						open: false,
						item: null,
					})
				}>
				<Modal.Header closeButton>
					<Modal.Title className="d-flex align-items-center gap-2">
						Notification
						{!modalInformation.item?.isReed ? (
							<Badge bg="danger" className="pulse-badge">
								NEW
							</Badge>
						) : (
							<Badge bg="secondary">Read</Badge>
						)}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					{/* STATUS */}
					{/* <div className="d-flex justify-content-between mb-3">
						<span className="fw-semibold text-secondary">Status</span>
						<Badge bg={modalInformation.item?.isReed ? "secondary" : "danger"}>
							{modalInformation.item?.isReed ? "Read" : "New"}
						</Badge>
					</div> */}

					{/* TIME */}
					<div className="d-flex justify-content-between mb-3">
						<span className="fw-semibold text-secondary">Time</span>
						<span>
							{moment(
								new Date(
									MainService.convertUTCToLocal(
										modalInformation.item?.createDate,
									),
								),
							)
								.startOf("minute")
								.fromNow()}
						</span>
					</div>

					<div className="p-3 bg-light rounded">
						<span
							dangerouslySetInnerHTML={{
								__html: modalInformation.item?.message,
							}}></span>
					</div>
				</Modal.Body>

				<Modal.Footer>
					<button
						className="btn btn-secondary"
						onClick={() => closeModal({ open: false, item: null })}>
						Close
					</button>
				</Modal.Footer>
			</Modal>

			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0">Notifications</h4>
					</div>
				</div>
			</Header>
			<Card className="mt-3">
				<CardBody>
					<div>
						<Form.Group className="mb-1" controlId="isDefault">
							<Form.Check // prettier-ignore
								type="switch"
								id="isActive"
								label={isNew ? "See oll" : "See new"}
								checked={isNew}
								onChange={event => {
									notificationGetAll(1, event.target.checked);
								}}
							/>
						</Form.Group>
					</div>

					<Table id="table" responsive hover className="mt-0">
						<thead>
							<tr>
								<th>#</th>
								<th>Message</th>
								<th>Status</th>
								<th>Date</th>
							</tr>
						</thead>
						<tbody>
							{!!data &&
								!!data.length &&
								data.map((item, index) => (
									<tr
										key={index}
										className="cursor-pointer"
										onClick={() => {
											openModal(item);
										}}>
										<td>{index + 1}</td>

										<td className=" " style={{ width: 100 }}>
											<span className="max-line-1">{item.message}</span>
										</td>
										<td>
											<span
												className={`badge ${
													item.isReed ? "bg-secondary" : "bg-danger new-badge"
												}`}
												style={{ fontSize: "0.9rem", padding: "0.5em 0.8em" }}>
												{item.isReed ? "Read" : "New"}
											</span>
										</td>
										<td className="text-nowrap">
											<span className="d-flex gap-2">
												{MainService.convertUTCToLocal(item.createDate)} (
												{moment(
													new Date(
														MainService.convertUTCToLocal(item.createDate),
													),
												)
													.startOf("minute")
													.fromNow()}
												)
											</span>
										</td>
										{/* <td>{item.createDate}</td> */}
									</tr>
								))}
						</tbody>
					</Table>

					<Pagination className="mt-3 mb-1 justify-content-end coustem_pagination align-self-stretch">
						<Pagination.First
							onClick={() => handlePageChange(1)}
							disabled={currentPage === 1}
						/>
						<Pagination.Prev
							onClick={() => handlePageChange(currentPage - 1)}
							disabled={currentPage === 1}
						/>
						<Pagination.Item className="coustem_pagination_item" active>
							{currentPage}
						</Pagination.Item>

						<Pagination.Next
							onClick={() => handlePageChange(currentPage + 1)}
							disabled={pagination?.totalPages === currentPage}
						/>
					</Pagination>
				</CardBody>
			</Card>
		</div>
	);
}

const loader = async () => {
	return [];
};

const Notifications = Object.assign(Component, { loader });

export default Notifications;
